<template>
  <div class="page-outbox">
    <!--搜索框-->
    <div class="search-group-wapper">
      <search-block @searchSub='searchSub' ref="searchBlock"></search-block>
    </div>
    <!--列表-->
    <div class="list-wapper">
      <scroll @scroll="scroll"
              @scrollToEnd="scrollToEnd"
              @scrollToTop="scrollToTop"
              :listen-scroll="listenScroll"
              :probe-type="probeType"
              :data="data"
              :pullup="true"
              class="listview"
              ref="listview">
        <ul class="query-list">
          <div class="pullDown">{{pullDownMsg}}</div>
          <p class="empty-list" v-if="data.length<1">暂无数据</p>
          <li class="list-item" v-for="(item,index) in data" ref="listGroup">
            <a href="javascript:void(0)" class="order-item-mask"></a>
            <h3 class="list-item-title">
              <span :class="{'minus':item.prepaylog_amount<0}">{{item.prepaylog_amount}}</span>
              <label>{{item.prepaylog_time}}</label>
            </h3>
            <div class="list-item-orderContent">
              {{item.prepaylog_note}}
            </div>
          </li>
          <div class="pullUp">{{pullUpMsg}}</div>
        </ul>
      </scroll>
    </div>
  </div>
</template>

<script>
  import SearchBlock from 'basic/searchBlock/searchBlock'
  import Scroll from 'basic/scroll/scroll'

  export default {
    name: '',
    data() {
      return {
        keyWord: '',
        curPage: 1,
        pageSize:15,
        data: [],
        pullDownMsg: "下拉刷新",
        pullUpMsg: "上拉加载",
        maxY: 0,
        hasMore: true,
        listenScroll: true,
        probeType: 3,
        orderStatusMap:['未审核','审核通过','审核通过','已取消'],
        orderTypeMap: [ '未付款','部分付款','全额付款']
      }
    },
    mounted(){
      if(this.$route.meta&&this.$route.meta.pageBelong){
        this.$store.commit('setPageBelong',this.$route.meta.pageBelong)
      }
      this._getData(true);
    },
    methods:{
      searchSub(keyWord){
        this.$router.push({path:'/GoodsList/'+keyWord})
      },
      refresh() {
        this.$refs.listview.refresh()
      },
      scroll(scrollPos,maxY) {
        if (scrollPos.y > 30) {
          this.pullDownMsg='释放刷新';
        }
        if(scrollPos.y<= (maxY - 40)&&this.hasMore){
          this.pullUpMsg='释放加载更多';
        }
      },
      scrollToEnd(){
        if(this.hasMore){
          this._getData();
        }

      },
      scrollToTop(){
        this.hasMore=true;
        this.curPage=1;
        this._getData(true);
      },
      payOrder(item){
        //先查支付信息  在跳支付页面
        this.$router.push({path:'/PayInfo/'})
      },
      cancelOrder(item){
        this.$toast('取消订单')
      },
      setListType(type,status){
        this.$store.commit('setCurOrderType',type);
        this.scrollToTop();
        this.$refs.listview.scrollTo(0,0);
      },
      _getData(clear){
        this.$cHttp.post('customers/prepaylog',{
          partner:this.$systemConfig.partner,
          apikey:this.$systemConfig.apikey,
          user_id:this.$store.state.userInfo.user_id,
          page_pernum:this.pageSize,
          current_page:this.curPage
        }).then((res)=>{
          console.log(res)
        if(res.status&&res.status==1){
          if(clear){
            this.$store.commit('setSubOrderInfo',{
              cus_prepay:res.data. cus_prepay,
              so_no:'',
              so_id:'',
              so_total:0
            })
            this.data=res.data.rows;
          }else{
            this.data=this.data.concat(res.data.rows);
          }
          if(this.curPage+1>res.data.total_page){
            this.hasMore=false;
            this.pullUpMsg='没有更多数据了';
          }else{
            this.curPage++;
          }
          if(res.data.rows.length<1){
            this.$toast('暂无数据');
          }
        }else{
          this.$toast('暂无数据')
        }
      }).catch((msg)=>{
          this.$toast(msg);
      })

      }
    },
    components:{
      SearchBlock,Scroll
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
    .listview{
    position: absolute;
    width: 100%;
    top: .61rem;
    left: 0;
    bottom: 0;
    overflow: hidden;
    .list-item{
      position:relative;
      padding:.15rem;
      border-bottom: 1px solid #eee;
      .order-item-mask{
        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color: rgba(0,0,0,0);
        &:active{
          background-color: rgba(0,0,0,.2);
        }
      }
      .list-item-title{
        display: flex;
        padding-bottom:.1rem;
        >label{
          flex: 1;
          font-size: .15rem;
          color: #666;
          text-align: right;
        }
        >span{
          font-size:.15rem;
          font-weight: bold;
          color: #00d539;
          &.minus{
            color:$mainColor;
          }
        }
      }
      .list-item-orderContent{
        font-size: .14rem;
        line-height: .18rem;
        color:#999;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/prepay/prepay.vue